<template>
    <div class="row justify-center items-center mainLoader">
        <video :poster="`${awsPath}site/images/video-placeholder.webp`" autoplay muted loop>
            <source :src="`${awsPath}site/media/pageloader.webm`" type="video/webm">
        </video>
    </div>
</template>
